import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CurrentLocaleComponent} from '../../../../../..//shared/components/current-locale-component';
import {KoeffizienteRowData} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m1';

@Component({
  selector: '[appKoeffizienteTableRowData]',
  templateUrl: './koeffiziente-table-row-data.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class KoeffizienteTableRowDataComponent
  extends CurrentLocaleComponent
  implements OnInit
{
  @Input() caption: string;
  @Input() rowData: KoeffizienteRowData;

  keys: string[] = [
    'nurGrundlohn',
    'ohneZulagen',
    'ohneSonderzahlungen',
    'dummyVariablenfuerAusbildung',
    'pqRegression',
    'standardAnalyseModell'
  ];

  constructor(protected readonly translate: TranslateService) {
    super(translate);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
